import React from "react";

export const SkeletonCard = () => (
    <div className="flex flex-col overflow-hidden rounded-2xl border border-zinc-100 bg-white">
        <div className="aspect-[4/3] w-full skeleton" />
        <div className="space-y-2 p-4">
            <div className="h-3 w-1/3 skeleton" />
            <div className="h-4 w-3/4 skeleton" />
            <div className="h-4 w-1/2 skeleton" />
            <div className="mt-3 h-5 w-1/3 skeleton" />
        </div>
    </div>
);

export const SkeletonGrid = ({ count = 8 }) => (
    <div className="grid grid-cols-2 gap-5 md:grid-cols-3 lg:grid-cols-4">
        {Array.from({ length: count }).map((_, i) => <SkeletonCard key={i} />)}
    </div>
);

export default SkeletonCard;
